import { BefehlFormProps, BefehlFormWrapper } from '../Generic'
import { Befehl24 } from '../../../models'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { useBefehlForm } from '../../../hooks'
import { Befehl24FormData, createBefehl24FormValidationSchema } from './schema'

import Auftrag24_11_12Form from './Auftrag24_11_12Form'
import Auftrag24_20_30Form from './Auftrag24_20_30Form'
import {
  convertBefehl24FormDataToModel,
  convertModelToBefehl24FormData
} from './converters'

export default function Befehl24Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-24-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl24>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl24FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl24FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl24FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl24FormData) => {
      const updatedBefehl = convertBefehl24FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl24FormData>
      befehlKennung="24"
      title={t('befehle.24.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      <div>
        <Auftrag24_11_12Form
          readOnly={readOnly}
          data-testid={`${testId}-auftrag-24-11-12`}
          activateEmptyFieldWarnings={activateEmptyFieldWarnings}
        />
        <Auftrag24_20_30Form
          readOnly={readOnly}
          data-testid={`${testId}-auftrag-24-20-30`}
          activateEmptyFieldWarnings={activateEmptyFieldWarnings}
        />
      </div>
    </BefehlFormWrapper>
  )
}
